import React from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import QuillReactEditor from "../../components/QuillReactEditor";
import TemplateTableGenerator from "../libraries/TemplateTableGenerator";
import { ReactComponent as CirclePlus } from "../../assets/icons/circlePlus.svg";
import { ReactComponent as AddEditor } from "../../assets/icons/addEditor.svg";
import { ReactComponent as AddTable } from "../../assets/icons/addTable.svg";
import { ReactComponent as DelIcon } from "../../assets/icons/delete_red.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/editPri.svg";
import MenuIcon from "../../assets/icons/Menu.png";

const ConsolFSBottomAddSection = ({
  bottomBlocks,
  onDragEndItems,
  updateEditorContent,
  removeItem,
  forceOpenTableId,
  setForceOpenTableId,
  updateTableItem,
  handleAddParagraph,
  handleAddTable,
  isAddingTable,
  setIsAddingTable,
  onNewTableBlock,
}) => {
  return (
    <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
      <DragDropContext onDragEnd={onDragEndItems}>
        <Droppable droppableId="consol-fs-bottom-items">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              style={{ display: "grid", gap: 20 }}
            >
              {bottomBlocks.map((it, idx) => (
                <Draggable key={it.id} draggableId={it.id} index={idx}>
                  {(dragProvided) => (
                    <div
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                      style={{
                        ...dragProvided.draggableProps.style,
                        width: "100%",
                      }}
                    >
                      {it.type === "text" ? (
                        <QuillReactEditor
                          value={it.text?.[0]?.content ?? " "}
                          onChange={(content) => {
                            updateEditorContent(it.id, content);
                          }}
                          dragHandleProps={dragProvided.dragHandleProps}
                          rightControl={
                            <DelIcon
                              style={{ cursor: "pointer", width: 16, height: 16, marginRight: 8 }}
                              onClick={() => removeItem(it.id)}
                            />
                          }
                        />
                      ) : (
                        <div
                          style={{
                            border: "1px solid #e3efe7",
                            borderRadius: "10px",
                            overflow: "hidden",
                            background: "#fff",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              background: "#f8f9f9",
                              display: "flex",
                              alignItems: "center",
                              padding: "10px 12px",
                              borderBottom: "1px solid #e3efe7",
                              gap: "12px",
                            }}
                          >
                            <div
                              {...dragProvided.dragHandleProps}
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <img src={MenuIcon} alt="drag" style={{ cursor: "grab", width: 9 }} />
                            </div>
                            <span
                              style={{
                                fontWeight: 600,
                                fontSize: "13px",
                                color: "#205a46",
                                textTransform: "uppercase",
                                flex: 1,
                              }}
                            >
                              {it.tableTitle || "Table"}
                            </span>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                              <EditIcon
                                style={{ cursor: "pointer", width: 16, height: 16 }}
                                onClick={() => setForceOpenTableId(it.id)}
                              />
                              <DelIcon
                                style={{ cursor: "pointer", width: 16, height: 16 }}
                                onClick={() => removeItem(it.id)}
                              />
                            </div>
                          </div>
                          <div style={{ background: "#fff", padding: 0 }}>
                            <TemplateTableGenerator
                              isDisclosureTable={true}
                              tableId={it.id}
                              forceOpen={it.id === forceOpenTableId}
                              value={{
                                tableTitle: it.tableTitle,
                                tableRow: it.tableRow,
                                tableColumn: it.tableColumn,
                                tableType: it.tableType,
                                table: it.table,
                                hasCellData: it.hasCellData,
                              }}
                              onChange={(next) => {
                                updateTableItem(it.id, {
                                  tableTitle: next.tableTitle,
                                  tableRow: next.tableRow,
                                  tableColumn: next.tableColumn,
                                  hasCellData: next.hasCellData,
                                  tableData: next.tableData,
                                  tableType: next.tableType,
                                  table: next.table,
                                });
                              }}
                              onAfterOpen={() => {
                                if (forceOpenTableId === it.id) setForceOpenTableId(null);
                              }}
                              hideHeader={true}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>

      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "center",
          padding: 12,
          borderRadius: 12,
          marginTop: 12,
        }}
      >
        <CirclePlus width={37} />
        <AddEditor width={140} onClick={handleAddParagraph} style={{ cursor: "pointer" }} />
        <AddTable width={100} onClick={handleAddTable} style={{ cursor: "pointer" }} />
      </div>

      {isAddingTable && (
        <div style={{ marginTop: "12px" }}>
          <TemplateTableGenerator
            isDisclosureTable={true}
            forceOpen={true}
            value={{}}
            onChange={(next) => {
              onNewTableBlock(next);
              setIsAddingTable(false);
            }}
            onCancel={() => setIsAddingTable(false)}
          />
        </div>
      )}
    </div>
  );
};

export default ConsolFSBottomAddSection;
